<template>
  <div
    v-if="show"
    class="fixed top-0 bottom-0 right-0 left-0 grid grid-cols-12 grid-rows-6 m-auto z-50 w-full h-full bg-gray-500/75">
    <div class="col-start-2 col-end-12 sm:col-start-5 sm:col-end-9 row-start-2 row-end-4 grid grid-cols-12 grid-rows-6 bg-white shadow shadow-gray-500 bg-white rounded-md">
      <p
        class="row-span-4 col-span-12 flex flex-row px-5 py-5 justify-center items-center"
        v-html="text"></p>
      <div class="row-span-2 col-span-12 flex justify-center items-center w-full">
        <button
          @click="submitConfirm()"
          class="bg-green-500 px-3 m-1 w-32 h-10 rounded-md text-sm text-white">{{ confirm.text || 'OKE' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupMessage',
  props: {
    message: Object,
    confirm: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    show: false,
    text: null,
    error: false
  }),
  watch: {
    message: function (message) {
      let text = this.message ? this.message.text : null

      if (text) {
        if (text instanceof Object) {
          let newText = ''

          for (var msg of text) {
            newText += `${msg.msg || ''}<br/>`
          }

          text = newText
        }

        text = `<span class="px-3 text-sm text-left text-gray-500">${text}</span>`

        if (message.status == 400 || message.status === 403) {
          this.error = true
          text = `<i class="material-icons px-3 text-5xl text-red-500 text-red-500">report_problem</i>${text}`
        } else {
          text = `<i class="material-icons px-3 text-5xl text-blue-500 text-blue-500">check_circle</i>${text}`
          this.error = false
        }

        this.show = true
        this.text = text
      } else {
        this.show = false
        this.text = null
      }
    }
  },
  methods: {
    submitConfirm: function () {
      this.show = false

      if (this.error) {
        if (this.message.status === 403) {
          this.$router.push({ path: '/salmontrack/login' })
        } else {
          if (typeof this.confirm.error === 'function') this.confirm.error()
        }
      } else {
        if (typeof this.confirm.success === 'function') this.confirm.success()
      }
    }
  }
}
</script>
